import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ShipmentASN } from '../../../../service/shipment-asn.service';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
interface PlantWithCode{
  plant__code:string
  name1:string
}
@Component({
  selector: 'app-add-user-role',
  templateUrl: './add-user-role.component.html',
  styleUrl: './add-user-role.component.scss'
})
export class AddUserRoleComponent implements OnInit{

  addUserRoleForm!: FormGroup;
  isLoading: boolean = false;
  vendorMenuList: any[] =[]
  plantList: any[] =[]
  constructor(private fb: FormBuilder,
              private vendorService: VendorTsService,
              private messageService: MessageService,
              private shipment_asn: ShipmentASN) { }

  ngOnInit(): void {
    this.addUserRoleForm = this.fb.group({
      role_name: ['', Validators.required],
      menu: ['', Validators.required],
      plant: ['', Validators.required],
    });
    this.getPlantList()
    this.vendorService.getVendorMenuList().then((res)=>{
      res.message.forEach((menu:any)=>{
        if (menu.name != "Vendor List" && menu.name != "Gate In" && menu.name != "Gate Out" && menu.name != "Token" && menu.name != "Visitor Pass" && menu.name != "Visitor Pass Out") {
          this.vendorMenuList.push(menu)
        }
      })
    }).catch((error)=>{
      console.log(error)
    })
  }

  onSubmit(){
    const data = {
      data: this.addUserRoleForm.value
    };
    this.isLoading = true
    this.vendorService.createRole(data).then((res)=>{
      if (res.message.status == "Failed") {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: res.message.message, life: 5000 });
      } else {
        this.messageService.add({ severity: 'success', summary: 'Successful', detail: res.message.message, life: 1000 });
        this.addUserRoleForm.reset()
      }
      this.isLoading = false
    }).catch((e)=>{
      console.log(e)
    })
  }

  getPlantList() {
    this.shipment_asn.getPlantList().then((res: any[]) => {
      res.forEach((data)=>{
        let plant:PlantWithCode = {
          plant__code:data.plant__code,
          name1: `${data.plant__code}-${data.name1}`
        }
        this.plantList.push(plant)
      })
    })
      .catch((error: any) => {
        console.log(error);
      });
  }

}
